export const LOAD_INTERVAL_TIME = 60000

export const EVENT_NEW_DATA = 'EVENT_NEW_DATA'
export const EVENT_TOURNAMENT_FOUND = 'EVENT_TOURNAMENT_FOUND'
export const EVENT_NEW_MEMBERSHIP_DATA = 'EVENT_NEW_MEMBERSHIP_DATA'
